module.exports = __webpack_public_path__ + "static/img/host_activity_rules.fefad90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/host_activity/host_activity_rules.png
// module id = DWr7
// module chunks = 0